import { render, staticRenderFns } from "./ListMotoristaTransbordoView.vue?vue&type=template&id=7832e0a4&"
import script from "./ListMotoristaTransbordoView.vue?vue&type=script&lang=ts&"
export * from "./ListMotoristaTransbordoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports